
import { Card } from "@/components/ui/card";
import { SurveyHeader } from "./SurveyHeader";
import { SurveyBasicInfo } from "./SurveyBasicInfo";
import { SurveyQuestions } from "./SurveyQuestions";
import { SurveyFooter } from "./SurveyFooter";
import type { GroupLeaderResponse } from "@/utils/validation";

interface SurveyFormProps {
  formData: GroupLeaderResponse;
  isSubmitting: boolean;
  onInputChange: (field: keyof GroupLeaderResponse, value: any) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  currentStep?: number; // Make this optional for backward compatibility
}

export const SurveyForm = ({
  formData,
  isSubmitting,
  onInputChange,
  onSubmit,
}: SurveyFormProps) => {
  console.log('🎯 SurveyForm received formData:', formData);
  return (
    <form onSubmit={onSubmit} className="space-y-8">
      <Card className="p-6">
        <SurveyHeader />
        <div className="space-y-6">
          <SurveyBasicInfo
            formData={formData}
            onInputChange={onInputChange}
          />
          <SurveyQuestions
            formData={formData}
            onInputChange={onInputChange}
          />
        </div>
      </Card>
      <SurveyFooter isSubmitting={isSubmitting} />
    </form>
  );
};
